// --- CONFIGURATION CONSTANTS ---

// LLM generation parameters
const LLM_TEMPERATURE = 0.7;
const LLM_TOP_P = 0.9;

// Token limits
const DEFAULT_MAX_TOKENS = 8192;
const ENHANCE_MAX_TOKENS = 1024;
// Transcribing a described workout. Starts at the generation default and
// escalates on truncation like generation does — 4096 was enough for a typical
// session and not for a real one ("10 rounds of 10 burpees, 5 deadlifts,
// 20 snatches…" is a long tree), and a ceiling that fits the common case while
// silently failing the interesting one is the wrong trade.
const LOG_WORKOUT_MAX_TOKENS = 8192;
// How far the retry will climb. Well under MAX_TOKEN_CEILING: a transcription
// that cannot fit in this has almost certainly gone wrong in some other way.
const LOG_WORKOUT_TOKEN_CEILING = 32768;
const TOKEN_ESCALATION_FACTOR = 2; // Double tokens on truncation retry
const MAX_TOKEN_CEILING = 65536; // Hard ceiling to prevent runaway costs
const THINKING_TOKEN_MULTIPLIER = 4; // Thinking models need headroom for reasoning + response

// Retry behaviour
const DEFAULT_MAX_RETRIES = 2;
const RETRY_BACKOFF_BASE_MS = 1000;

// Post-processing
const TIMING_DEVIATION_TOLERANCE = 0.15; // 15% deviation triggers scaling
const TIME_ROUNDING_STEP_S = 5; // Round adjusted durations to nearest N seconds
const MIN_DURATION_S = 5; // Floor for scaled durations
// Time-scaling factors inside this band produce natural intervals; outside it
// the round-nudging pass runs first (issue #63).
const NATURAL_SCALE_MIN = 0.67;
const NATURAL_SCALE_MAX = 1.5;
const NUDGE_MAX_ITERATIONS = 8; // Cap on greedy round-count adjustments

// Schema
const MAX_SCHEMA_DEPTH = 5;

// Dynamic example defaults by fitness level
const REPS_BY_LEVEL = { beginner: 10, intermediate: 12, advanced: 15 };
const WORK_TIME_BY_LEVEL_S = { beginner: 30, intermediate: 40, advanced: 50 };
const DEFAULT_REPS = 12;
const DEFAULT_WORK_TIME_S = 40;

export {
  LLM_TEMPERATURE,
  LLM_TOP_P,
  DEFAULT_MAX_TOKENS,
  ENHANCE_MAX_TOKENS,
  LOG_WORKOUT_MAX_TOKENS,
  LOG_WORKOUT_TOKEN_CEILING,
  TOKEN_ESCALATION_FACTOR,
  MAX_TOKEN_CEILING,
  THINKING_TOKEN_MULTIPLIER,
  DEFAULT_MAX_RETRIES,
  RETRY_BACKOFF_BASE_MS,
  TIMING_DEVIATION_TOLERANCE,
  TIME_ROUNDING_STEP_S,
  MIN_DURATION_S,
  NATURAL_SCALE_MIN,
  NATURAL_SCALE_MAX,
  NUDGE_MAX_ITERATIONS,
  MAX_SCHEMA_DEPTH,
  REPS_BY_LEVEL,
  WORK_TIME_BY_LEVEL_S,
  DEFAULT_REPS,
  DEFAULT_WORK_TIME_S,
};
